export default interface IIdentificationRequest {
  fullSsn?: string;
  dateOfBirth?: string;
  ssnLast4Digits?: string;
  monthlyIncome: number;
  housingExpenseType: string;
  monthlyHousing: number;
}

export const isIIdentificationRequest = (value: Partial<IIdentificationRequest>): value is IIdentificationRequest => {
  if (value.monthlyIncome === undefined) {
    return false;
  }
  if (value.monthlyHousing === undefined) {
    return false;
  }
  return true;
}
